import { Button, Flex, Paper, Text, Title } from '@mantine/core';
import { IconPencil } from '@tabler/icons-react';
import { Link, useParams } from 'react-router';
import { formatPhoneNumber } from '@shared/helpers';

type UserCardProps = {
  isEdit?: boolean;
  firstName?: string;
  lastName?: string;
  email?: string;
  group?: string;
  company?: string;
  phone?: string;
  editLink?: string;
};

export const UserCard = ({
  isEdit = false,
  firstName,
  lastName,
  email,
  group,
  company,
  phone,
  editLink,
}: UserCardProps) => {
  const { id } = useParams();

  return (
    <Paper p={24} radius={16} bg='primary.0' w='100%' maw={1070}>
      <Flex gap={24} direction='column'>
        <Flex w='100%' justify='space-between' wrap='wrap'>
          <Title order={4}>Личные данные</Title>

          {isEdit && (
            <Button
              variant='subtle'
              size='md'
              leftSection={<IconPencil size={20} />}
              component={Link}
              to={editLink ? editLink : `/user-list/${id}/edit`}
            >
              Редактировать
            </Button>
          )}
        </Flex>

        <Flex gap={24} wrap={{ base: 'wrap', sm: 'nowrap' }} w='100%'>
          <Flex direction='column' gap={24} flex='1 1 50%'>
            <Flex direction='column' gap={8}>
              <Text c='tertiary.7' size='sm'>
                Фамилия
              </Text>
              <Text c='primary.7'>{lastName || '-'}</Text>
            </Flex>

            <Flex direction='column' gap={8}>
              <Text c='tertiary.7' size='sm'>
                Email
              </Text>
              <Text c='primary.7'>{email || '-'}</Text>
            </Flex>

            <Flex direction='column' gap={8}>
              <Text c='tertiary.7' size='sm'>
                Группа
              </Text>
              <Text c='primary.7'>{group || '-'}</Text>
            </Flex>
          </Flex>

          <Flex direction='column' gap={24} flex='1 1 50%'>
            <Flex direction='column' gap={8}>
              <Text c='tertiary.7' size='sm'>
                Имя
              </Text>
              <Text c='primary.7'>{firstName || '-'}</Text>
            </Flex>

            <Flex direction='column' gap={8}>
              <Text c='tertiary.7' size='sm'>
                Номер телефона
              </Text>
              <Text c='primary.7'>{formatPhoneNumber(phone) || '-'}</Text>
            </Flex>

            <Flex direction='column' gap={8}>
              <Text c='tertiary.7' size='sm'>
                Компания
              </Text>
              <Text c='primary.7'>{company || '-'}</Text>
            </Flex>
          </Flex>
        </Flex>
      </Flex>
    </Paper>
  );
};
